import { getStore } from "app/store/store"
import { isImageFile, isVideoFile } from "app/tools/file"
import { ICreativeFileType, MEDIA_CONTENT_TYPES, MEDIA_TYPES } from "media/model"

export function getCreativeTypeFromMimeType(mimeType: string | null): ICreativeFileType {
  return isImageFile(mimeType) ? "image" : isVideoFile(mimeType) ? "video" : "archive"
}

export function getMediaTypeId(type: MEDIA_TYPES): number {
  const mediaType = getStore()
    .getState()
    .media.mediaTypes.find(m => m.type === type)
  if (!mediaType) {
    throw Error(`Media type '${type}' not found`)
  }
  return mediaType.id
}

export function isImageContentType(contentType: number): boolean {
  return contentType === 2
}

export function getContentTypeId(contentType: MEDIA_CONTENT_TYPES): number {
  switch (contentType) {
    case MEDIA_CONTENT_TYPES.TEXT: {
      return 1
    }
    case MEDIA_CONTENT_TYPES.IMAGE: {
      return 2
    }
    case MEDIA_CONTENT_TYPES.FLASH: {
      return 3
    }
    case MEDIA_CONTENT_TYPES.EXTERNAL: {
      return 4
    }
    case MEDIA_CONTENT_TYPES.SCRIPT: {
      return 5
    }
    case MEDIA_CONTENT_TYPES.VIDEO: {
      return 7
    }
    case MEDIA_CONTENT_TYPES.EXTERNAL_IMAGE: {
      return 8
    }
    case MEDIA_CONTENT_TYPES.EXTERNAL_VAST: {
      return 9
    }
    case MEDIA_CONTENT_TYPES.HTML5: {
      return 12
    }
    case MEDIA_CONTENT_TYPES.AUDIO: {
      return 13
    }
    case MEDIA_CONTENT_TYPES.EXTERNAL_DAAST: {
      return 14
    }
    case MEDIA_CONTENT_TYPES.NATIVE: {
      return 15
    }
  }
}
